<template>
  <div id="v-steel">
    <vs-row vs-w="12" vs-type="flex" vs-justify="space-between" vs-align="center">
      <div class="card_header">
        <h2>{{ header[index] }}</h2>
      </div>
      <div class="card_header">
        <h3>เลขที่ใบสั่งซื้อ : {{orderNumber}}</h3>
      </div>
    </vs-row>
    <vs-row vs-w="12">
      <vs-col vs-w="6" vs-sm="12" vs-xs="12">
        <vs-row vs-w="12" vs-type="flex" vs-justify="center" vs-align="center">
          <h1 class="header">ความยาว (มม.)</h1>
          <vs-card>
            <div class="result">
              <div class="title-value">
                <div class="title">
                  <span>ตั้งค่า:</span>
                </div>
                <div class="value length">
                  <span>{{ lengthSet }}</span>
                </div>
              </div>
              <div class="title-value">
                <div class="title">
                  <span>ค่าปัจจุบัน:</span>
                </div>
                <div class="value length">
                  <span>{{ lengthPresent }}</span>
                </div>
              </div>
            </div>
          </vs-card>
        </vs-row>
      </vs-col>
      <vs-col vs-w="6" vs-sm="12" vs-xs="12">
        <vs-row vs-w="12" vs-type="flex" vs-justify="center" vs-align="center">
          <h1 class="header">ปริมาณ (ชิ้น)</h1>
          <vs-card>
            <div class="result">
              <div class="title-value">
                <div class="title">
                  <span>ตั้งค่า:</span>
                </div>
                <div class="value quantity">
                  <span>{{ quantitySet }}</span>
                </div>
              </div>
              <div class="title-value">
                <div class="title">
                  <span>ค่าปัจจุบัน:</span>
                </div>
                <div class="value quantity">
                  <span>{{ quantityPresent }}</span>
                </div>
              </div>
            </div>
          </vs-card>
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-row vs-w="12">
      <vs-col vs-w="12" vs-type="flex" vs-justify="center" vs-align="center">
        <div class="machine">
          <div class="progress-state">
            <div class="start"></div>
            <span class="circle stop"></span>
            <vs-progress
              class="rtl"
              :height="12"
              :percent="progress"
              color="success"
              >success</vs-progress
            >
            <div class="circle"></div>
            <div class="end"></div>
          </div>
          <div>
            <img
              src="@/assets/images/V-Steel/machine_on.gif"
              alt=""
              v-if="machine"
            />
            <img src="@/assets/images/V-Steel/machine_off.png" alt="" v-else />
          </div>
        </div>
      </vs-col>
    </vs-row>
    <vs-row vs-w="12" vs-type="flex" vs-justify="center" vs-align="center">
      <!-- <span class="footer" contenteditable="true">{{ footer[index] }}</span> -->
    </vs-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lengthSet: null,
      lengthPresent: null,
      quantitySet: null,
      quantityPresent: null,
      machine: null,
      progress: null,
      place: "",
      index: null,
      footer: [
        "ตำบลสนับทึบ อำเภอวังน้อย จังหวัดพระนครศรีอยุธยา 13170",
        "8 ม.11 ตำบลบึงทองหลาง อำเภอลำลูกกา ปทุมธานี 12150",
        "140 ตำบลสนับทึบ อำเภอวังน้อย จังหวัดพระนครศรีอยุธยา 13170",
        "ตำบลลำไทร อำเภอวังน้อย จังหวัดพระนครศรีอยุธยา 13170",
        "8JF6+8W2 ตำบลบ้านกรด อำเภอบสงประอิน จังหวัดพระนครศรีอยุธยา",
      ],
      header: [
        "Maxsale",
        "วี-บิ้วท์ ลำลูกกา",
        "วี-สตีล อยุธยา",
        "ที-วัน บ้านโป่ง",
        "ที-วัน รัตนาธิเบศร์",
      ],
      delay: 5* 1000,
      timer: null,
      orderNumber:0,
    };
  },
  mounted() {
    console.log(this.$route.params.place);
    this.place = this.$route.params.place;
    this.index = Number(this.$route.params.place.slice(-1)) - 1;
    this.getData();

    
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  // watch: {
  //   $route(to, from) {
  //     // react to route changes...
  //     // this.$forceUpdate()
  //     console.log("watch");
  //     console.log(this.$route.params.place);
  //     this.place = this.$route.params.place;
  //     this.index = Number(this.$route.params.place.slice(-1)) - 1;
  //     clearInterval(this.timer);

  //     this.timer = setInterval(() => {
  //       this.getData();
  //     }, this.delay);
  //   },
  // },
  methods: {
   async getData() {
    await  this.$API
        .get("vsteel/currentdata/" + this.place)
        .then((res) => {
          console.log(res);
          // console.log("res", res);
          this.lengthSet = Number(res.data[0].lsv);
          this.lengthPresent = Number(res.data[0].lcv);
          this.quantitySet = Number(res.data[0].qsv);
          this.quantityPresent = Number(res.data[0].qcv);

          this.machine = res.data[0].motor_status == 0 ? false : true;

          this.progress =
            this.quantitySet != 0
              ? (this.quantityPresent / this.quantitySet) * 100
              : 0;
          this.orderNumber = res.data[0].report
          // console.log(this.progress);
        })
        .catch(() => {
          console.log("catch");
          this.lengthSet = null;
          this.lengthPresent = null;
          this.quantitySet = null;
          this.quantityPresent = null;
          this.machine = null;
          this.progress = null;
        });
        this.timer = setTimeout(() => {
      this.getData();
    }, this.delay);
    },
  },
};
</script>

<style lang="scss" scoped>
$font_color: rgb(88, 88, 88);

.rtl {
  direction: rtl;
}
.card_header {
  background: var(--background-color-sidebar);
  box-shadow: 0 0px 10px 0px #b1b1b1;
  border-radius: 10px;
  padding: 5px;
  margin-bottom: 10px;
  h2 {
    font-weight: bold;
  }
}
.header {
  font-weight: bold;
  color: $font_color;
}
.result {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .title-value {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      width: 100%;
      span {
        font-size: 1.5rem;
        font-weight: bold;
        color: $font_color;
      }
    }
    .value {
      width: 100%;
      background: rgb(65, 109, 137);
      border: rgb(177, 177, 177) 2px solid;
      border-radius: 5px;
      display: flex;
      justify-content: flex-end;
      padding: 5px;
      &.length {
        background: rgb(65, 109, 137);
      }
      &.quantity {
        background: rgb(66, 134, 60);
      }
      span {
        color: white;
        font-size: 2rem;
        font-weight: bold;
      }
    }
  }
}
.machine {
  width: 100%;
  .progress-state {
    width: 100%;

    display: flex;
    align-items: center;
    // flex-wrap: nowrap;
    // display: grid;
    // grid-template-columns: min-content auto auto auto min-content;
    // display: block;
    gap: 10px;
    .start {
      width: 5%;
    }
    .circle {
      height: 20px;
      width: 28px;
      background-color: #bbb;
      border-radius: 50%;
      // margin: 5px;
      // display: block;
      &.success {
        background-color: #32c040;
      }
      &.stop {
        background-color: rgb(255, 0, 0);
      }
    }
    .end {
      width: 25%;
    }
  }
  img {
    width: 100%;
  }
}
.footer {
  color: #bbb;
  font-size: 1rem;
  cursor: default;
}
</style>